import { observer } from 'mobx-react-lite';
import { ReactNode } from 'react';
import { RawIntlProvider } from 'react-intl';

import { useSDK } from '../app';
import { LoadingView } from '../components/loadingView';

export const I18n = observer(({ children }: { children: ReactNode }) => {
	const sdk = useSDK();
	if (!sdk.locale.intl) {
		return sdk.uiStateStore.opened ? <LoadingView /> : null;
	}

	return <RawIntlProvider value={sdk.locale.intl}>{children}</RawIntlProvider>;
});
